import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import type { TextColor } from '@lib/colors/colors'
import type { ReactNode } from 'react'

export default function Banner({
  containerClassName,
  textColor = 'text-white',
  value,
}: {
  containerClassName?: string
  textColor?: TextColor
  value: ReactNode
}) {
  return (
    <div
      className={classMerge(
        `w-full bg-success600 px-2 text-center`,
        containerClassName,
      )}
    >
      <Text className={textColor} styleName='p' value={value} />
    </div>
  )
}
